module.exports = __webpack_public_path__ + "static/media/hammerhead.ed979de5.svg";